import { lazy } from 'react';

// project import
import Loadable from './Loadable';
import MinimalLayout from '../layout/LoginLayout';
//import useAxiosPrivate from '../auth_services/useAxiosPrivate';
//const axiosPrivate = useAxiosPrivate();

// render - login
const Login = Loadable(lazy(() => import('../pages/authentication/Login')));
const Register = Loadable(lazy(() => import('../pages/authentication/Register')));
const Billonline = Loadable(lazy(() => import('../pages/bill/Billonline')));
const ResetPassword = Loadable(lazy(() => import('../pages/authentication/ResetPassword')));
const RegisterSuccess = Loadable(lazy(() => import('../pages/authentication/RegisterSuccess')));
const MerchantSetup = Loadable(lazy(() => import('../pages/authentication/MerchantSetup')));
const Welcome = Loadable(lazy(() => import('../pages/authentication/Welcome')));
const RegisterPackage = Loadable(lazy(() => import('../pages/package/RegisterPackage')));
const PackageView = Loadable(lazy(() => import('../pages/package/PackageView')));

// ==============================|| AUTH ROUTING ||============================== //

//const res = axiosPrivate.get('authtoken');
//console.log(res);

const title = 'Thana';

const LoginRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/',
            element: <Login />
        }, {
            path: '/login',
            element: <Login />
        }, {
            path: '/register',
            element: <Register />
        }, {
            path: '/billonline/:billno',
            element: <Billonline />
        }, {
            path: '/resetpassword',
            element: <ResetPassword />
        }, {
            path: '/register/package',
            element:
                <RegisterPackage
                    documentTitle={`Package - ${title}`}
                    pageTitle='ແພັກແກັດ'
                    menuActive='/register/package'
                    payment_status='register/package/payment'
                />
        }, {
            path: '/package',
            element: <PackageView />
        }, {
            path: '/register/success',
            element: <RegisterSuccess />
        }, {
            path: '/register/welcome',
            element: <Welcome />
        }, {
            path: '/register/merchant_setup',
            element: <MerchantSetup />
        }, {
            path: '*',
            element: <>Page Not Found</>
        }
    ]
};

export default LoginRoutes;
